import { render } from "./BankCollected.vue?vue&type=template&id=058f43cf"
import script from "./BankCollected.vue?vue&type=script&lang=js"
export * from "./BankCollected.vue?vue&type=script&lang=js"

import "./BankCollected.vue?vue&type=style&index=0&id=058f43cf&lang=less"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__